export const STATIC_IMAGE_MODULE_ID = "StaticImage";
export const RICH_TEXT_MODULE_NAMESPACE = "pagebuilder-Module";
